const ServiceType = {
  fe: 1,
  fes: 2,
};

export default ServiceType;
